import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { getUserUtcOffset } from '../shared/utils/helpers';

/**
 * Gmail-style compact timestamp for inbox list cards.
 *  • today            → time only            e.g. "10:34"
 *  • earlier this week → weekday + time       e.g. "Tue 11:23"
 *  • older (same year) → weekday + day/month  e.g. "Fri 18/07"
 *  • older (prior year)→ day/month/year        e.g. "18/07/25"
 * 24-hour clock; weekday names follow the active locale (en/fr/it).
 */
@Pipe({
  name: 'mailTime',
})
export class MailTimePipe implements PipeTransform {
  currentLang: string =
    localStorage.getItem('lang') ??
    this.translateService.currentLang ??
    this.translateService.defaultLang ??
    'en';

  constructor(private readonly translateService: TranslateService) {}

  /** @param full when true, returns the absolute localized date/time (for tooltips). */
  transform(date_time: Date | string, full = false): string {
    if (!date_time || date_time === '') {
      return '';
    }

    const offsetHours = getUserUtcOffset() ?? 0;
    const m = moment(date_time).add(offsetHours, 'hours').locale(this.currentLang);
    const now = moment();

    if (full) {
      return m.format('dddd DD MMMM YYYY, HH:mm');
    }

    if (m.isSame(now, 'day')) {
      return m.format('HH:mm');
    }
    if (now.diff(m, 'days') < 7) {
      return m.format('ddd HH:mm');
    }
    if (m.isSame(now, 'year')) {
      return m.format('ddd DD/MM');
    }
    return m.format('DD/MM/YY');
  }
}
